export default __webpack_public_path__ + "static/media/nerd-wallet.fdfb7835.jpg";